<template>
  <q-card flat bordered>
    <q-card-section class="row items-center justify-between wrap q-pb-none">
      <span class="text-h5 q-mb-md">{{ title }}</span>

      <div class="row items-center wrap">
        <q-tabs v-model="tab" class="q-mb-md" dense narrow-indicator stretch>
          <q-tab :label="$t('pages.doctor.tabs.account')" name="account" />
          <q-tab :label="$t('pages.doctor.tabs.credits')" name="credits" />
        </q-tabs>

        <div v-if="buttons" class="row items-center wrap q-ml-md">
          <template v-for="button of buttons">
            <q-btn
              v-if="button.isAllowed"
              :key="button"
              :color="button.color"
              :label="button.label"
              :outline="button.isOutline"
              class="q-mb-md q-ml-sm"
              @click="button.onClick"
            />
          </template>
        </div>
      </div>
    </q-card-section>

    <q-card-section v-if="error">
      <q-banner class="text-white bg-red q-mb-md" rounded>
        {{ error.message }}
      </q-banner>
    </q-card-section>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="account">
        <DoctorAccountTab
          :doctor="doctor"
          @update:title="onTitleUpdate"
          @update:buttons="onButtonsUpdate"
          @update:doctor="onDoctorUpdate"
        />
      </q-tab-panel>

      <q-tab-panel name="credits">
        <DoctorCreditsTab
          :doctor="doctor"
          @update:title="onTitleUpdate"
          @update:buttons="onButtonsUpdate"
          @update:doctor="onDoctorUpdate"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-card>
</template>

<script>
import { mapMutations } from 'vuex';
import { getDoctorById } from '@/api/doctors';
import DoctorAccountTab from '@/components/DoctorAccountTab.vue';
import DoctorCreditsTab from '@/components/DoctorCreditsTab.vue';

let initialData = {};

export default {
  components: {
    DoctorAccountTab,
    DoctorCreditsTab,
  },
  data() {
    return {
      title: null,
      buttons: null,
      tab: 'account',
      error: initialData.error,
      doctor: initialData.doctor,
    };
  },
  meta() {
    return {
      title: this.$t('pages.doctor.documentTitle', {
        title: this.doctor?.user.fullName,
      }),
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const doctor = await getDoctorById(+to.params.doctorId);

      initialData.doctor = doctor;
    } catch (error) {
      initialData.error = error;
    } finally {
      next();
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      this.error = null;

      const doctor = await getDoctorById(+to.params.doctorId);

      this.doctor = doctor;
    } catch (error) {
      this.error = error;
    } finally {
      next();
    }
  },
  created() {
    this.setDoctor(this.doctor?.user.fullName);
  },
  methods: {
    ...mapMutations({
      setDoctor: 'breadcrumbs/setDoctor',
    }),
    onTitleUpdate(title) {
      this.title = title;
    },
    onButtonsUpdate(buttons) {
      this.buttons = buttons;
    },
    onDoctorUpdate(doctor) {
      this.doctor = doctor;
    },
  },
};
</script>
